import {createSlice} from '@reduxjs/toolkit'

const bltChangeReviewSlice = createSlice({
    name : "bltChangeReview",
    initialState : {
        queueItem : null
    },
    reducers : {
        setChangeReviewQueueItem(state, action) { 
            state.queueItem = action.payload
        }
    }
})

export const { 
    setChangeReviewQueueItem, 
} = bltChangeReviewSlice.actions

export default bltChangeReviewSlice.reducer
